'use client'

import * as React from 'react'
import { VariantProps, cva } from 'class-variance-authority'

const $mktInput = cva(
  'bg-dark-base border transition-colors placeholder:select-none border-dark-border-solid focus:border-[#FF6C00] placeholder:text-dark-faint focus:outline-none rounded-md p-3.5 text-dark-bright xl:text-sm h-12 w-full'
)

export type MktInputProps = VariantProps<typeof $mktInput> &
  React.JSX.IntrinsicElements['input']

export const MktInput = React.forwardRef<HTMLInputElement, MktInputProps>(
  ({ className, ...inputProps }, ref) => {
    return (
      <input {...inputProps} ref={ref} className={$mktInput({ className })} />
    )
  }
)
